AFRAME.registerComponent('user-menu', {
    init: function () {
        this.createMenu();
    },

    createMenu: function () {
        const menu = document.createElement('a-entity');
        menu.setAttribute('id', 'main-menu-container');
        menu.setAttribute('layout', 'type: box; columns: 1; align: center; marginColumn: 2.5; marginRow: .7;');
        // menu.setAttribute('position', '-.68 -0.4 0.01');  // set at top level
        menu.setAttribute('scale', '.15 .15 .15');

        // this.createMenuButton(menu, 'Stock Chart', 'stock-chart', '0.5 0 0.01');
        this.createMenuButton(menu, '/mwl/nta0list', 'myportfolio-price', '0.5 0 0.01', '#b89900');


        this.el.appendChild(menu);
    },

    createMenuButton: function (parent, label, action, position, color = '#008CBA') {
        const button = document.createElement('ui-button');
        button.setAttribute('label', label);
        button.setAttribute('type', 'rounded-box');
        button.setAttribute('color', color);
        button.setAttribute('opacity', '.6');
        button.setAttribute('width', '2.3');  // Let's use a fixed width for all buttons
        // button.setAttribute('position', position); // ignored while using layout mode
        // button.setAttribute('autosize', "true");


        button.addEventListener('click', () => {
            this.handleMenuAction(action);
        });

        parent.appendChild(button);
    },

    handleMenuAction: function (action) {

        if (action === 'myportfolio-price') {
            const centerPanel = document.getElementById('large-center-panel');
            if (centerPanel) {
                let centerContent = document.getElementById('large-center-panel-content');
                if (centerContent) {
                    centerContent.replaceChildren();
                    centerContent.setAttribute('position', '0 0 0');
                }
                addMyPortfolioPriceCubeToCenterPanel();
            }
        } else if (action === 'myportfolio-sector') {
            const centerPanel = document.getElementById('large-center-panel');
            if (centerPanel) {
                let centerContent = document.getElementById('large-center-panel-content');
                if (centerContent) {
                    centerContent.replaceChildren();
                    centerContent.setAttribute('position', '0 0 0');
                }
                addMyPortfolioSectorCubeToCenterPanel();
            }
        }
    }

});
